module.exports = __webpack_public_path__ + "static/media/mimi7.ace546bd.gif";